import { Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Location } from '@angular/common';
import { ApiService } from 'src/app/services/api.service';
import { ErrorText } from 'src/app/enums/error-text.enum';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { OptionalItemGroupModel } from 'src/app/models/form-group.model';


@Component({
  selector: 'fury-optional-item-add-edit',
  templateUrl: './optional-item-add-edit.component.html',
  styleUrls: ['./optional-item-add-edit.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class OptionalItemAddEditComponent implements OnInit {
  optionalItemForm!: FormGroup;
  covereditemid: any;
  imageBasePath!: string;
  bannerImage!: string;

  constructor(
    public apiservice: ApiService,
    private activatedroute: ActivatedRoute,
    private router: Router,
    public location: Location, private el: ElementRef,
  ) {
  }

  ngOnInit(): void {
    this.activatedroute.params.subscribe((res: any) => {
      this.covereditemid = res?.id;
      if (this.covereditemid) this.getDetails(this.covereditemid);
    });
    this.formInit();
  }

  formInit() {
    this.optionalItemForm = new FormGroup<OptionalItemGroupModel>({
      title: new FormControl('', [Validators.required]),
      metaTitle: new FormControl('', [Validators.required]),
      metaDescription: new FormControl('', [Validators.required]),
      bannerImage: new FormControl(''),
      description: new FormControl('', [Validators.required]),
      bannerDescription: new FormControl(''),
      isActive: new FormControl(true),
      planType: new FormControl(''),
    });
  }

  getDetails(categoryId: string) {
    this.apiservice.get(`admin/plan/optional-item-category/get-optional-item-category/${categoryId}`).subscribe((res: any) => {
      if (res.body) {
        if (res.body.planOptionalItemCategory.bannerImage) {
          this.bannerImage = res.body.planOptionalItemCategory.bannerImage;
        }
        this.optionalItemForm.patchValue({
          title: res.body.planOptionalItemCategory.title,
          metaTitle: res.body.planOptionalItemCategory.metaTitle,
          metaDescription: res.body.planOptionalItemCategory.metaDescription,
          description: res.body.planOptionalItemCategory.description,
          bannerDescription: res.body.planOptionalItemCategory.bannerDescription,
          planType: res.body.planOptionalItemCategory.planType || '',
          isActive: res.body.planOptionalItemCategory.isActive
        });
      }
    }, err => {
    });
  }

  onImageUpload(event: any) {
    if (event.target.files[0].type === 'image/jpeg' || event.target.files[0].type === 'image/png' || event.target.files[0].type === 'image/jpg') {
      let file;
      file = event.target.files[0];
      this.optionalItemForm.patchValue({ bannerImage: file });
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.bannerImage = e.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      this.apiservice.alert(ErrorText.ImageRestriction, 'error');
    }
  }

  addOrUpdateOptionalItem() {
    if (this.optionalItemForm.valid) {
      
        const data = new FormData();

        Object.keys(this.optionalItemForm.value).forEach(fieldName => {
          if (this.optionalItemForm.controls[fieldName].value) {
            data.append(fieldName, this.optionalItemForm.value[fieldName]);
          }
        });
        const path = this.covereditemid ? `admin/plan/optional-item-category/update-optional-item-category/${this.covereditemid}` : 'admin/plan/optional-item-category/create-optional-item-category';
        this.apiservice.postMultiData(path, data).subscribe((res: any) => {
          if (res.body) {
            this.apiservice.alert(res.body.message, ErrorType.Success);
            this.location.back();
          } else { this.apiservice.alert(res.body.message, ErrorType.Warning); }
        }, err => {
          if (err) { this.apiservice.alert(err.body.errors.title, ErrorType.Error); }
        });
      
    } else {
      this.optionalItemForm.markAllAsTouched();
      const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector("input.ng-invalid");
      const textAreaInvalidControl: HTMLElement = this.el.nativeElement.querySelector("textarea.ng-invalid");
      if(firstInvalidControl){firstInvalidControl.focus()} //without smooth behavior
      if(!firstInvalidControl && textAreaInvalidControl){textAreaInvalidControl.focus()} //without smooth behavior
    }

  }


  back() {
    this.location.back();
  }

}
